import {type VFC} from 'react';
import {Redirect} from 'react-router-dom';
import PublicApplicationLayout from '../../layouts/PublicLayout.js';
import {ROUTE_PATHS} from '../../utils/constants/public/psr.js';

const NotFoundPage: VFC = () => (
  <PublicApplicationLayout>
    <Redirect to={ROUTE_PATHS.PAYMENT_SYSTEMS_REGULATOR_PATH} />
  </PublicApplicationLayout>
);

export default NotFoundPage;
